module.exports = __webpack_public_path__ + "static/media/dubai.c6fe56e1.jpg";